export class StepperController {
    private steps: Array<InterACT.Interfaces.ISteps>;
    private nextSteps: InterACT.Interfaces.ISteps;
    private previousSteps: InterACT.Interfaces.ISteps;

    constructor() {
        this.steps = [];
    }

    public setActiveStep = (step) => {
        angular.forEach(this.steps, (currentStep) => {
            currentStep.active = false;
            currentStep.check = true;
        });
        step.active = true;
        step.check = false;
    };

    public moveForward = (index) => {
        let activeStep: InterACT.Interfaces.ISteps = {};
        angular.forEach(this.steps, (step) => {
            if (step.active) {
                activeStep = step;
            }
        });
        this.nextSteps = this.steps[index + 1];
        if (angular.isDefined(this.nextSteps)) {
            activeStep.active = false;
            this.nextSteps.active = true;
            activeStep.check = true;
            this.nextSteps.check = false;
        }
    };

    public moveBackward = (index) => {
        let activeStep: InterACT.Interfaces.ISteps = {};
        angular.forEach(this.steps, (step) => {
            if (step.active) {
                activeStep = step;
            }
        });
        this.previousSteps = this.steps[index - 1];
        if (this.previousSteps) {
            activeStep.active = false;
            this.previousSteps.active = true;
            activeStep.check = false;
            this.previousSteps.check = false;
        }
    };

    public addStep = (step) => {
        if (this.steps.length === 0) {
            this.setActiveStep(step);
        }
        this.steps.push(step);
    };
}